import { memo } from 'react';

import { TagIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type WorkspaceAgentTagPillProps = {
  label: string;
  /** Steps the label up a weight. */
  selected?: boolean;
  /** A pick-several pick: takes the chip's picked fill and outline. */
  tinted?: boolean;
};

/**
 * Read-only tag pill for the search dock's tag rows and the tag approval table. The outline is an inset
 * ring because altitude-2 barely shows on the white list, and a ring keeps the pill's size.
 */
export const WorkspaceAgentTagPill = memo(({ label, selected = false, tinted = false }: WorkspaceAgentTagPillProps) => (
  <span
    className={cn(
      'inline-flex min-w-0 max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-12 text-gray-12 leading-4 transition-colors',
      tinted ? 'bg-altitude-2 ring-1 ring-altitude-6 ring-inset' : 'bg-gray-4',
      selected ? 'font-semibold' : 'font-medium',
    )}
    data-testid="WORKSPACE_AGENT_TAG_PILL"
  >
    <TagIcon aria-hidden className="size-3 shrink-0" />
    <span className="truncate">{label}</span>
  </span>
));

WorkspaceAgentTagPill.displayName = 'WorkspaceAgentTagPill';
